import React from 'react'
import { Tag, Tooltip } from 'antd'
import PropTypes from 'prop-types'
/**
 * CustomTag component wraps AntD’s Tag to optionally display a Tooltip around its children.
 * It applies a default CSS class (`we-custom-tag`) for consistent styling.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.tooltip] – Text to show inside a Tooltip when hovering over the tag.
 * @param {React.ReactNode} props.children – The content to render inside the Tag.
 * @param {...any} props – All other AntD Tag props (color, icon, etc.) are forwarded.
 * @returns {JSX.Element}
 */
const CustomTag = ({ tooltip, ...props }) => {
	return (
		<Tag {...props} className="we-custom-tag">
			{tooltip ? (
				<Tooltip title={tooltip}>{props.children}</Tooltip>
			) : (
				props.children
			)}
		</Tag>
	)
}

CustomTag.propTypes = {
	tooltip: PropTypes.string,
	children: PropTypes.node
}
export default CustomTag
